import { useEffect, useState } from "react";
import { VisitTargetWeekModal } from "./Modal/VisitTargetWeekModal";
import { useAuthState } from "../../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { DailyWorkChecklistProgressDashboardAPI } from "../../../../Redux/DailyWorkChecklistProgress/DailyWorkChecklistProgressSlice";
import { Loading } from "../../../../Helper/Loading";

export const OfficialVisitN = (props) => {
  const { FinancialYear, AssetID, WorkType } = props
  const userDetails = useAuthState();
  const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
  const { UserID, token, } = userDetails.user
  const dispatch = useDispatch()

  const [OpenModal, setOpenModal] = useState(false);
  const [Flag, setFlag] = useState("");
  const [officerData, setOfficerData] = useState(null)
  const [weekID, setWeekID] = useState(0)


  const handlePopupOpen = (data, week, type, count, desig) => {
    if (count) {
      if (data && type === "VisitTarget" && desig === "Garden  Assistant") {
        setOfficerData(data)
        setWeekID(week)
        setFlag("VisitTarget")
        setOpenModal(true);
      }
      if (data && type === "Achievement") {
        setOfficerData(data)
        setWeekID(week)
        setFlag("Achievement")
        setOpenModal(true);
      }

      if (data && type === "Pending" && desig === "Garden  Assistant") {
        setOfficerData(data)
        setWeekID(week)
        setFlag("Pending")
        setOpenModal(true);
      }
    }

  };

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  useEffect(() => {
    const data = {
      M_FinancialYearID: year.ID,
      M_MonthID: Month.ID,
      M_ZoneID: 0,
      M_WardID: 0,
      M_AssetTypeID: AssetID,
      M_WorkTypeID: WorkType.ID,
      M_UsersID: UserID,
      Flag: "Garden",
      token: token,

    }
    dispatch(DailyWorkChecklistProgressDashboardAPI({ data }))
  }, [AssetID, year.ID, Month.ID, WorkType.ID])

  const { tableData, isLoading } = useSelector(state => state.DailyWorkChecklistProgressDashboardSliceData)


  return (
    <>
      {isLoading && <Loading />}
      <div
        className="row m-0 p-0  bg-white"
        style={{
          border: "1px solid #0d467ee6",
          borderRadius: "8px ",
          width: "100%",
          overflow: "scroll",
        }}
      >
        <div className="col-12 pt-3 pb-0 m-1">
          <table
            id="totalordergenerated"
            cellPadding="0"
            cellSpacing="0"
            border="0"
            className="table table-bordered "
            style={{ textAlign: "center" }}
          >
            <thead className="gardenworktable" id="customers">
              <tr className="text-center ">
                <th colSpan={22} className="text-center fw-bold fs-6 py-2" style={{ background: '#048a8b' }}>Garden Work Daily Checklist Progress</th>
              </tr>

              <tr className="text-center tablethhead2">
                {tableData && tableData?.mainHeading && tableData?.mainHeading.length > 0 &&
                  tableData?.mainHeading.map((i) => {
                    return (
                      <th
                        colSpan={i.no}
                        className="text-center fw-bold fs-6"
                        id="tablecolor"
                      >
                        {i.manihead}
                      </th>
                    );
                  })}
              </tr>

              <tr
                className="text-center gardenworkth"
                style={{ width: "100%" }}
              >
                {tableData && tableData?.heading && tableData?.heading.length > 0 &&
                  tableData?.heading.map((j) => {
                    // <></>
                    return (
                      <th
                        className="text-center fw-bold"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {j.head}
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody>
              {tableData && tableData?.data.length > 0 && tableData?.data.map((designation) => {
                return designation.rowdata?.map((officer, officerIndex) => {
                  const rowSpan = designation.rowdata?.length || 1;
                  return (
                    <tr
                      className="text-center"
                      key={`${designation.designationName}-${officerIndex}`}
                    >
                      {officerIndex === 0 ? (
                        <td className="text-center" rowSpan={rowSpan}>{designation.designationName}</td>
                      ) : null}

                      <td style={{ whiteSpace: "nowrap" }}>{officer.employeeName}</td>
                      <td>{officer.wardName}</td>

                      <td
                        onClick={() => handlePopupOpen(officer, 1, "VisitTarget", officer.week1_VisitTarget, designation.designationName)}
                        className="bluecolorCount text-center ">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week1_VisitTarget > 0) ? "cursor-pointer_bg" : "cursor-none"}>{officer.week1_VisitTarget}</span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 1, "Achievement", officer.week1_Achievement)}
                        className={"greencolorCount text-center "}>
                        <span className={officer.week1_Achievement > 0 ? "cursor-pointer_bg" : 'cursor-none'}>
                          {officer.week1_Achievement}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 1, "Pending", officer.week1_Pending, designation.designationName)}
                        className="orangecolorCount text-center ">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week1_Pending > 0) ? "cursor-pointer_bg" : 'cursor-none'}>
                          {officer.week1_Pending}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 2, "VisitTarget", officer.week2_VisitTarget, designation.designationName)}
                        className="bluecolorCount text-center">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week2_VisitTarget > 0) ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week2_VisitTarget}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 2, "Achievement", officer.week2_Achievement)}
                        className="greencolorCount text-center">
                        <span className={officer.week2_Achievement > 0 ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week2_Achievement}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 2, "Pending", officer.week2_Pending, designation.designationName)}
                        className="orangecolorCount text-center ">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week2_Pending > 0) ? "cursor-pointer_bg" : 'cursor-none'}>
                          {officer.week2_Pending}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 3, "VisitTarget", officer.week3_VisitTarget, designation.designationName)}
                        className="bluecolorCount text-center">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week3_VisitTarget > 0) ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week3_VisitTarget}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 3, "Achievement", officer.week3_Achievement)}
                        className="greencolorCount text-center">
                        <span className={officer.week3_Achievement > 0 ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week3_Achievement}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 3, "Pending", officer.week3_Pending, designation.designationName)}
                        className="orangecolorCount text-center ">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week3_Pending > 0) ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week3_Pending}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 4, "VisitTarget", officer.week4_VisitTarget, designation.designationName)}
                        className="bluecolorCount text-center">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week4_VisitTarget > 0) ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week4_VisitTarget}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 4, "Achievement", officer.week4_Achievement)}
                        className="greencolorCount text-center">
                        <span className={officer.week4_Achievement > 0 ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week4_Achievement}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 4, "Pending", officer.week4_Pending, designation.designationName)}
                        className="orangecolorCount text-center ">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week4_Pending > 0) ? "cursor-pointer_bg" : 'cursor-none'}>
                          {officer.week4_Pending}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 5, "VisitTarget", officer.week5_VisitTarget, designation.designationName)}
                        className="bluecolorCount text-center">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week5_VisitTarget > 0) ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week5_VisitTarget}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 5, "Achievement", officer.week5_Achievement)}
                        className="greencolorCount text-center">
                        <span className={officer.week5_Achievement > 0 ? "cursor-pointer_bg" : "cursor-none"}>
                          {officer.week5_Achievement}
                        </span>
                      </td>

                      <td
                        onClick={() => handlePopupOpen(officer, 5, "Pending", officer.week5_Pending, designation.designationName)}
                        className="orangecolorCount text-center ">
                        <span className={(designation.designationName == "Garden  Assistant" && officer.week5_Pending > 0) ? "cursor-pointer_bg" : 'cursor-none'}>
                          {officer.week5_Pending}
                        </span>
                      </td>

                      <td className="bluecolorCount text-center">
                        {officer.total_VisitTarget}
                      </td>

                      <td className="greencolorCount text-center">
                        {officer.total_Achievement}
                      </td>

                      <td className="orangecolorCount text-center">
                        {officer.total_Pending}
                      </td>
                      {/* <td>{officer["KPI Assign"]}</td> */}
                    </tr>
                  );
                });
              })}
            </tbody>
          </table>
        </div>
      </div>

      {OpenModal &&
        <VisitTargetWeekModal
          handleOpenModal={handlePopupOpen}
          ApiFlag={Flag}
          handleCloseModal={handleCloseModal}
          weekID={weekID}
          officerData={officerData}
          FinancialYear={FinancialYear}
          Month={Month}
          M_AssetTypeID={AssetID}
          WorkType={WorkType}

        />
      }
    </>
  )
}

